import React from 'react';
import classes from './Modal.module.css';

const modal = (props) => {
  const modalClasses = [classes.Modal, classes[props.className]];
  if (props.show === true) {
    modalClasses.push(classes.Shown);
  } else {
    modalClasses.push(classes.Hidden);
  }
  if (props.fullScreen) modalClasses.push(classes.FullScreen);
  if (props.hideOverlay) modalClasses.push(classes.HideOverlay);
  if (props.shortWindow === true) modalClasses.push(classes.ShortWindow);
  if (props.transparentModal === true) modalClasses.push(classes.Transparent);

  function handleModalClick(e) {
    if (e.target.id === 'modalFrame' && props.closeOnOutsideClick) props.close();
  }

  const modalContainer = document.getElementById('modal-container');
  if (modalContainer) {
    if (props.fullScreen) {
      modalContainer.style.margin = '0';
    } else if (props.className === 'PostForm' && window.innerHeight <= 728) {
      modalContainer.style.margin = '20px auto';
    } else if (props.className === 'MemberInviteModal') {
      modalContainer.style.margin = '40px auto';
    } else {
      modalContainer.style.margin = 'calc(50vh - 325px) auto';
    }
  }

  return (
    <div id="modalFrame" name={props.name} onClick={handleModalClick} className={modalClasses.join(' ')}>
      <section id="modal-container" className={classes.modalMain}>
        {props.children}
      </section>
    </div>
  );
};

export default modal;
